import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDeleteBrandingMutation } from 'src/api/branding/hooks';
import { useGlobalModals } from 'src/contexts/global-modals';
import { links } from 'src/router/routes';

export const useDeleteBranding = () => {
  const {
    deleteBrandingModal,
    closeDeleteBrandingModal,
    openLoadingModal,
    closeLoadingModal,
  } = useGlobalModals();
  const { deleteBrandingMutation, isPending } = useDeleteBrandingMutation();
  const navigate = useNavigate();

  const open = deleteBrandingModal.opened;
  const brandingId = deleteBrandingModal.brandingId;

  const handleConfirm = useCallback(async () => {
    if (!brandingId) {
      return;
    }

    openLoadingModal(
      'Deleting branding',
      'Please wait while we delete the branding...'
    );
    closeDeleteBrandingModal();

    try {
      await deleteBrandingMutation(brandingId);
      navigate(links.brandings);
    } finally {
      closeLoadingModal();
    }
  }, [
    closeDeleteBrandingModal,
    closeLoadingModal,
    deleteBrandingMutation,
    brandingId,
    navigate,
    openLoadingModal,
  ]);

  const handleClose = useCallback(() => {
    closeDeleteBrandingModal();
  }, [closeDeleteBrandingModal]);

  return {
    handleClose,
    handleConfirm,
    isPending,
    open,
  };
};
